import React from "react";
import { Redirect } from "react-router-dom";
import { auth } from "store/auth";

class LogoutView extends React.PureComponent {
  componentDidMount() {
    // We do a synchronous logout that forces termination of all in-flight
    // requests. This is to avoid a race condition where a user can logout
    // before receiving / setting the auth token. While this solution is
    // not ideal, it prevents us from having to rewrite the auth / login
    // flow.
    auth.clearToken();
    window.location.reload();
  }

  render() {
    return <Redirect to="/login" />;
  }
}

export { LogoutView };
